<template>
  <div class="service-payment">
      <h5>購買流程<span id="anchor_process"></span></h5>
      <ol>
        <li>選擇商品加入購物車，客製化商品須完成所有規格選擇與資料輸入。</li>
        <li>輸入購買人基本資料，加入 Line@。</li>
        <li>輸入訂購資訊完成訂單。</li>
        <!-- <li>付款方式目前除第三方支付平台「綠界」支付系統外，另提供現金轉帳帳號。</li> -->
        <li>付款方式提供現金轉帳帳號。</li>
        <li>選擇物流方式 : 物流寄送。</li>
      </ol>
      <h5>如何購買？<span id="anchor_howBuy"></span></h5>
      <p>
        下列幾種方式您可以向『金牌王國』購買物品：
        <ol>
          <li>網站線上訂購<br/>請先註冊帳號，帳號註冊成功後依循購物流程即可完成線上訂購。</li>
          <li>電話或網路聯繫<br/>特殊規格之客製商品，可直接透過電子信箱提供想法與稿件，或可於營業時間直接來電(06)2266-300、專線電話：0986-669-288，我們將有專人為您服務。</li>
          <li>至營業處購買<br/>請先來電(06)2266-300、專線電話：0986-669-288詢問，確認有您欲購買的商品再前往營業處。</li>
        </ol>
      </p>
      <h5>確認訂單<span id="anchor_order"></span></h5>
      <p>
        當您按下&quot;送出訂單&quot;時，系統將會發出E-MAIL確認信，以及line@訂單確認訊息，您也可以登入我的帳戶查看您的訂單狀態。下列是訂單的各種狀態：
        <ol>
          <li>等待付款：已收到您所完成的訂單，請遵守訂單價格有效期限，在限定時間1個工作天內完成付款程序。</li>
          <li>逾時通知(超過1天)：因貴金屬價格即時變動的特性，因此您的訂單只能保留至隔天晚上12時。</li>
          <li>已收到付款：已確認收到您的款項，系統將會發出E-MAIL確認信，以及line@收款確認訊息，進行出貨或取貨程序。</li>
          <li>等待商品出貨：您訂單部分商品已出貨，部分商品將等待現貨的補足後為您寄出。</li>
          <li>完成出貨：您訂單商品已全數出貨。</li>
          <li>已取消：表示您已取消該筆訂單。</li>
        </ol>
      </p>
      <h5>付款<span id="anchor_pay"></span></h5>
      <!-- <p>目前線上付款接透過綠界科技。</p> -->
      <p>付款方式提供現金轉帳帳號，資訊如下：<br>戶名：金牌王國金行許洋洋<br>分行名稱：彰化銀行 台南分行<br>銀行代號：009<br>銀行帳號：64020188887900</p>
      <h5>營業稅<span id="anchor_payment"></span></h5>
      <p>網站上所刊載的商品價格皆已包含營業稅5%(黃金免稅)，不需要給付額外稅務項目，請安心購買。</p>
      <h5>訂單有效期限<span id="anchor_period"></span></h5>
      <p>因國際貴金屬市場不斷波動，訂單價格以您收到的E-MAIL或LINE@訊息為準，一旦收到E-MAIL訂單後價格不會再變動，逾時未付款將取消該筆訂單。若消費者仍需要保留該筆訂單，則可要求系統重新報價。</p>
      <h5>取消訂單<span id="anchor_cancel"></span></h5>
      <ol>
        <li>消費者逾時未付款情形，視為取消該筆訂單。</li>
        <li>若因網站報價系統錯誤，而出現金價落差，本公司有權取消訂單，並保有最後出貨權利。</li>
      </ol>
      <h5>退貨<span id="anchor_return"></span></h5>
      <p>所有訂單皆爲百分之百客製，付之製作並送達客戶手中之商品無法退貨。</p>
      <h5>缺貨<span id="anchor_noArticle"></span></h5>
      <p>如遇特殊狀況（如缺貨、斷貨）系統將會通知。</p>
      <h5>價格調整政策<span id="anchor_adjustment"></span></h5>
      <p>因應國際市場貴金屬市場價格浮動，貴金屬商品價格每3分鐘將調整一次，如果你尚未送出訂單，商品價格仍會不斷更新直到您完成訂單。</p>
      <div class="mobile_backNav" v-if="isMobileButtonShow">
        <i class="fa fa-angle-left"></i>
        <router-link to="/gold/service_mobile">返回說明與服務</router-link>
      </div>
  </div>
</template>

<script>
export default {
  name: "servicePayment",
  data() {
    return {
      isMobileButtonShow: false
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-payment {
  width: 66.73%;
  text-align: left;
  h5 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin: 17px 0;
    position: relative;
  }
  h5:first-of-type {
    margin-top: 0;
  }
  p,
  ol,
  div {
    font-size: 17px;
    color: $secondaryDeepColor1;
  }
  ol {
    padding-left: 1em;
    margin: 0;
  }
  div {
    margin-left: -1em;
  }
  ol,
  p,
  div {
    line-height: 30px;
  }
  span {
    position: absolute;
    bottom: calc(100% + 80px);
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
</style>
